import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SelectChangeEvent } from 'primeng/select';
import { OsmosisService } from '../../services/osmosis.service';
import { NotificationBannerHistoryComponent } from '../notification-banner-history/notification-banner-history.component';
import { CommonSharedModule } from '../../common/shared.module';

@Component({
  selector: 'app-notification-banner',
  templateUrl: './notification-banner.component.html',
  styleUrls: ['./notification-banner.component.scss'],
  standalone: true,
  imports: [NotificationBannerHistoryComponent, CommonSharedModule]
})
export class NotificationBannerComponent implements OnInit {
  notificationBannerForm!: FormGroup;
  @ViewChild('notificationBannerHistory', { static: false })
  notificationBannerHistory!: NotificationBannerHistoryComponent;
  selectedProgramType = { programTypeID: 1, programName: 'MCAP' };
  loading = false;
  bannerText = '';
  isActive = false;
  startStopText = 'Loading...';
  bannerMessageHelp = 'Use <strong> for bold text and <a href> for links.';
  currentBanner!: string;
  programTypeId = 1;

  programtypes = [
    { programName: 'MCAP', programTypeID: 1 },
    { programName: 'CSI', programTypeID: 2 },
    { programName: 'Operator', programTypeID: 3 },
    { programName: 'Events', programTypeID: 4 }
  ];

  constructor(
    private formBuilder: FormBuilder,
    private osmService: OsmosisService
  ) {}

  ngOnInit() {
    this.selectedProgramType = { programTypeID: 1, programName: 'MCAP' };
    this.onFromGroup();
    this.refreshBanner();
  }

  onFromGroup() {
    this.notificationBannerForm = this.formBuilder.group({
      bannerMessage: ['']
    });
  }

  getBannerStatus() {
    this.loading = true;
    this.osmService
      .isFeatureEnabled(
        'NotificationBanner',
        this.selectedProgramType.programTypeID
      )
      .subscribe(
        response => {
          this.loading = false;
          this.isActive = response;
          this.updateStartStopText(response);
        },
        () => (this.loading = false)
      );
  }

  getBanner(programTypeId: number = this.selectedProgramType.programTypeID) {
    this.loading = true;
    this.osmService.getNotificationBanner(programTypeId).subscribe(
      response => {
        this.loading = false;
        this.currentBanner = response;
        this.notificationBannerForm.controls['bannerMessage'].setValue(
          response
        );
      },
      () => (this.loading = false)
    );
  }

  refreshBanner() {
    this.getBannerStatus();
    this.getBanner(this.selectedProgramType.programTypeID);
    if (this.notificationBannerHistory) {
      this.notificationBannerHistory.getBannerHistory(
        this.selectedProgramType.programTypeID
      );
    }
  }

  startStopBanner() {
    this.loading = true;
    this.osmService
      .updateFeature(
        'NotificationBanner',
        !this.isActive,
        this.selectedProgramType.programTypeID
      )
      .subscribe(
        () => {
          this.loading = false;
          const bannerMessage =
            this.notificationBannerForm.controls['bannerMessage'].value;
          if (
            !this.isActive &&
            (this.currentBanner == null || this.currentBanner != bannerMessage)
          )
            this.updateBanner();
          else this.refreshBanner();
        },
        () => (this.loading = false)
      );
  }

  updateBanner() {
    const bannerMessage =
      this.notificationBannerForm.controls['bannerMessage'].value;
    if (
      !!bannerMessage &&
      bannerMessage.length > 0 &&
      bannerMessage.length <= 560
    ) {
      const msg = {
        message: bannerMessage,
        programTypeId: this.selectedProgramType.programTypeID
      };
      this.loading = true;
      this.osmService.updateNotificationBanner(msg).subscribe(
        () => {
          this.loading = false;
          this.refreshBanner();
        },
        () => (this.loading = false)
      );
    }
  }

  private updateStartStopText(active: boolean) {
    this.startStopText = active ? 'Stop banner' : 'Start Banner';
  }

  get isUpdateButton(): boolean {
    if (this.isActive) {
      const bannerMessage =
        this.notificationBannerForm.controls['bannerMessage'].value;
      return bannerMessage == this.currentBanner;
    }
    return true;
  }

  get isStartButton(): boolean {
    if (!this.isActive) {
      if (
        this.notificationBannerForm.controls['bannerMessage'].value.length > 0
      ) {
        return true;
      }
      return false;
    } else {
      return true;
    }
  }

  get getLimit(): number {
    return (
      560 - this.notificationBannerForm.controls['bannerMessage'].value.length
    );
  }

  onProgramTypeChange(event: SelectChangeEvent): void {
    this.selectedProgramType =
      this.programtypes.find(pt => pt.programTypeID === (event as any).value) ||
      this.selectedProgramType;

    this.getBanner(this.selectedProgramType.programTypeID);
    this.notificationBannerHistory.getBannerHistory(
      this.selectedProgramType.programTypeID
    );
    this.refreshBanner();
  }
}
